export const RECEIVE_GET_EXPERIMENT_LIST = 'RECEIVE_GET_EXPERIMENT_LIST'
export const REQUEST_GET_EXPERIMENT_LIST = 'REQUEST_GET_EXPERIMENT_LIST'
export const FAILED_GET_EXPERIMENT_LIST = 'FAILED_GET_EXPERIMENT_LIST'
